module.exports = __webpack_public_path__ + "img/hr-cargo-wagon-door-horizontal-side.c6db0c6a.png";